import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/plugin/framer/")({
  component: FramerPlaceholder,
});

function FramerPlaceholder() {
  return (
    <main className="flex h-screen flex-col items-center justify-center p-8 text-center">
      <h1 className="text-xl font-semibold">Deflow for Framer</h1>
      <p className="mt-2 max-w-prose text-sm text-muted-foreground">
        Coming soon. The Framer integration is being scaffolded — the host
        adapter is in place, the routes are wired, and the UI shell will be
        ported over from the Figma plugin in an upcoming release.
      </p>
    </main>
  );
}
